"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.shouldUpdateBozzaBollettinoPostale = exports.resetRiepilogoBollettino = exports.resetEsitoBollettino = exports.autorizzaRevocaBollettinoPostale = exports.autorizzaRevocaBollettinoPostalePremarcato = exports.autorizzaRevocaBollettinoPostaleBianco = exports.getInfoRevocaBollettinoPostale = exports.getInfoRevocaBollettinoPostalePremarcato = exports.getInfoRevocaBollettinoPostaleBianco = exports.setBollettinoPostaleTipoSelected = exports.setBollettinoPostaleSalvaBozzaValidation = exports.setBollettinoPostaleRevocaSetStep = exports.setProvenienzaRevocaBollettinoPostale = exports.setRiepilogoRevocaBollettinoPostale = exports.getBollettinoFromBozza = exports.setBollettinoPostaleSetAlias1Click = exports.setBollettinoPostaleSetSalva1Click = exports.setBollettinoPostaleSetIntestatario = exports.setBollettinoPostaleSetCausale = exports.resetBollettinoPostale = exports.setBollettinoPostaleSetRipeti = exports.setBollettinoPostaleSetFormSubmitted = exports.setBollettinoPostaleSetBozzaSalvata = exports.setBollettinoPostaleSetStep = exports.setBollettinoPostaleSetStepAction = exports.setBollettinoPostaleSetTipoDataPagamento = exports.setBollettinoPostaleSetTipoDocumento = exports.setBollettinoPostaleSetNumeroBollettino = exports.setBollettinoPostaleSetCap = exports.setBollettinoPostaleSetCitta = exports.setBollettinoPostaleSetProvincia = exports.setBollettinoPostaleSetIndirizzo = exports.setBollettinoPostaleSetEsecutore = exports.setBollettinoPostaleSetImporto = exports.setBollettinoPostaleSetIdUtenza = exports.setBollettinoPostaleSetRapportoSelezionato = exports.getOneClickBollettinoPostale = exports.getOneClickBollettinoPostaleBianco = exports.delBozzaBollettinoPostale = exports.getBozzaBollettinoPostale = exports.getBozzeBollettinoPostale = exports.getInfoAutenticazioneBollettinoPostale = exports.getInfoAutenticazioneBollettinoPostalePremarcato = exports.getInfoAutenticazioneBollettinoPostaleBianco = exports.autorizzaBollettinoPostale = exports.autorizzaBollettinoPostalePremarcato = exports.autorizzaBollettinoPostaleBianco = exports.controlloBollettinoPostale = exports.getParametriBollettinoPostale = void 0;
const api_rest_1 = require("@sparkasse/api-rest");
const __1 = require("..");
const general_actions_1 = require("../general/general.actions");
const general_configuration_1 = require("../general/general.configuration");
const helpers_1 = require("../helpers");
const bollettinoPostale_selectors_1 = require("./bollettinoPostale.selectors");
const moment = require("moment");
/* get parametri - START */
function getParametriBollettinoPostaleStart() {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_GET_PARAMETRI_START
    };
}
function getParametriBollettinoPostaleSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_GET_PARAMETRI_SUCCESS,
        payload
    };
}
function generalError(value, showGenericModalError, sendErrorToMatomo, dispositiva, nomeEvento) {
    return async (dispatch) => {
        dispatch((0, general_actions_1.setError)(value, showGenericModalError));
        (!!dispositiva && !!sendErrorToMatomo) && sendErrorToMatomo('dispositiva', `code_error ${dispositiva} ${value.status} / ${value === null || value === void 0 ? void 0 : value.message} / ${value.timestamp}`, nomeEvento);
    };
}
function getParametriPerRipetiBollettinoPostaleSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_GET_PARAMETRI_PER_RIPETI_SUCCESS,
        payload
    };
}
const getParametriBollettinoPostale = (ripeti) => async (dispatch, _, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(getParametriBollettinoPostaleStart());
    if (extraArguments.mock) {
        Promise.resolve().then(() => require('../../mock/parametri_mav.json')).then(parametri => {
            dispatch(ripeti ? getParametriPerRipetiBollettinoPostaleSuccess((0, api_rest_1.ParametriBollettiniPostaliDtoFromJSON)(parametri)) : getParametriBollettinoPostaleSuccess((0, api_rest_1.ParametriBollettiniPostaliDtoFromJSON)(parametri)));
            dispatch((0, general_actions_1.setLoader)(false));
        });
    }
    else {
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.BollettinoPostaleControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).parametriBollettinoPostale().then((response) => {
                dispatch(ripeti ? getParametriPerRipetiBollettinoPostaleSuccess(response) : getParametriBollettinoPostaleSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.getParametriBollettinoPostale = getParametriBollettinoPostale;
/* get parametri - FINE */
/* controllo - START */
function controlloBollettinoPostaleStart() {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_CONTROLLO_START
    };
}
function controlloBollettinoPostaleSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_CONTROLLO_SUCCESS,
        payload
    };
}
const controlloBollettinoPostale = (funzioneDispositiva) => async (dispatch, getState, extraArguments) => {
    const bollettinoPostale = getState().bollettinoPostale;
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(controlloBollettinoPostaleStart());
    if (extraArguments.mock) {
        Promise.resolve().then(() => require('../../mock/controllo_mav.json')).then(parametri => {
            dispatch(controlloBollettinoPostaleSuccess((0, api_rest_1.BollettinoPostaleDtoFromJSON)(parametri)));
        });
    }
    else {
        const controlloBollettinoPostaleRequest = {
            bollettinoPostaleDto: funzioneDispositiva === 'bianco' ? (0, bollettinoPostale_selectors_1.buildBollettinoPostaleBianco)(bollettinoPostale) : (0, bollettinoPostale_selectors_1.buildBollettinoPostalePremarcato)(bollettinoPostale)
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.BollettinoPostaleControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).checkBollettinoPostale(controlloBollettinoPostaleRequest).then((response) => {
                dispatch(controlloBollettinoPostaleSuccess(response));
                dispatch((0, general_actions_1.setLoader)(false));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.controlloBollettinoPostale = controlloBollettinoPostale;
/* controllo - FINE */
/* autorizza - START */
function autorizzaBollettinoPostaleStart() {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_AUTORIZZA_START
    };
}
function autorizzaBollettinoPostaleSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_AUTORIZZA_SUCCESS,
        payload
    };
}
const autorizzaBollettinoPostaleBianco = (idDispositiva, credenziale) => async (dispatch, getState, extraArguments) => {
    (0, exports.autorizzaBollettinoPostale)(idDispositiva, credenziale)(dispatch, getState, extraArguments);
};
exports.autorizzaBollettinoPostaleBianco = autorizzaBollettinoPostaleBianco;
const autorizzaBollettinoPostalePremarcato = (idDispositiva, credenziale) => async (dispatch, getState, extraArguments) => {
    (0, exports.autorizzaBollettinoPostale)(idDispositiva, credenziale)(dispatch, getState, extraArguments);
};
exports.autorizzaBollettinoPostalePremarcato = autorizzaBollettinoPostalePremarcato;
const autorizzaBollettinoPostale = (idDispositiva, credenziale) => async (dispatch, _, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(autorizzaBollettinoPostaleStart());
    if (extraArguments.mock) {
        Promise.resolve().then(() => require('../../mock/autorizza_mav.json')).then(parametri => {
            dispatch(autorizzaBollettinoPostaleSuccess((0, api_rest_1.EsitoAutorizzazioneDisposizioneBollettinoPostaleDtoFromJSON)(parametri)));
            dispatch((0, general_actions_1.setLoader)(false));
        });
    }
    else {
        const InfoDispositivaBollettinoPostaleRequest = {
            idDispositiva: idDispositiva,
            credenzialeDispositivaDto: credenziale
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.BollettinoPostaleControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).autorizzaBollettinoPostale(InfoDispositivaBollettinoPostaleRequest).then((response) => {
                dispatch(autorizzaBollettinoPostaleSuccess(response));
                extraArguments.sendEventToMatomo('BOLLETTINO_POSTALE', `esito dispositiva BOLLETTINO_POSTALE ${response.stato}`, 'ESITO_DISPOSITIVA');
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error), false, extraArguments.sendEventToMatomo, 'BOLLETTINO_POSTALE', 'ESITO_DISPOSITIVA'));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.autorizzaBollettinoPostale = autorizzaBollettinoPostale;
/* autorizza - FINE */
/* get info autenticazione - START */
function getInfoAutenticazioneBollettinoPostaleStart() {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_GET_INFO_AUTENTICAZIONE_START
    };
}
function getInfoAutenticazioneBollettinoPostaleSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_GET_INFO_AUTENTICAZIONE_SUCCESS,
        payload
    };
}
const getInfoAutenticazioneBollettinoPostaleBianco = (idDispositiva, eseguiInit, chiamataUscente, offline) => async (dispatch, getState, extraArguments) => {
    (0, exports.getInfoAutenticazioneBollettinoPostale)(idDispositiva, eseguiInit, chiamataUscente, offline)(dispatch, getState, extraArguments);
};
exports.getInfoAutenticazioneBollettinoPostaleBianco = getInfoAutenticazioneBollettinoPostaleBianco;
const getInfoAutenticazioneBollettinoPostalePremarcato = (idDispositiva, eseguiInit, chiamataUscente, offline) => async (dispatch, getState, extraArguments) => {
    (0, exports.getInfoAutenticazioneBollettinoPostale)(idDispositiva, eseguiInit, chiamataUscente, offline)(dispatch, getState, extraArguments);
};
exports.getInfoAutenticazioneBollettinoPostalePremarcato = getInfoAutenticazioneBollettinoPostalePremarcato;
const getInfoAutenticazioneBollettinoPostale = (idDispositiva, eseguiInit, chiamataUscente, offline) => async (dispatch, _, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(getInfoAutenticazioneBollettinoPostaleStart());
    if (extraArguments.mock) {
        Promise.resolve().then(() => require('../../mock/autenticazione-bonifico.json')).then(parametri => {
            dispatch(getInfoAutenticazioneBollettinoPostaleSuccess((0, api_rest_1.InformazioniAutenticazioneDispositivaDtoFromJSON)(parametri)));
            dispatch((0, general_actions_1.setLoader)(false));
        });
    }
    else {
        const requestParameters = {
            idDispositiva: idDispositiva,
            chiamataUscente,
            eseguiInit,
            offline: !!offline
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.BollettinoPostaleControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).informazioniAutenticazioneBollettinoPostale(requestParameters).then((response) => {
                dispatch(getInfoAutenticazioneBollettinoPostaleSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.getInfoAutenticazioneBollettinoPostale = getInfoAutenticazioneBollettinoPostale;
/* get info autenticazione - FINE */
/* get bozze - START */
function getBozzeBollettinoPostaleStart() {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_GET_BOZZE_START
    };
}
function getBozzeBollettinoPostaleSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_GET_BOZZE_SUCCESS,
        payload
    };
}
const getBozzeBollettinoPostale = (request) => async (dispatch, _, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(getBozzeBollettinoPostaleStart());
    if (extraArguments.mock) {
        Promise.resolve().then(() => require('../../mock/bozze_mav.json')).then(bozze => {
            // dispatch(getBozzeBollettinoPostaleSuccess(BollettinoPostaleDtoFromJSON(bozze)));
            dispatch((0, general_actions_1.setLoader)(false));
        });
    }
    else {
        const getBozzeBollettinoPostaleRequest = {
            bozzeInDto: {
                tipologia: request.tipologia,
                codiceRapporto: request.codiceRapporto
            }
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.BollettinoPostaleControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).getBozzeBollettinoPostale(getBozzeBollettinoPostaleRequest).then((response) => {
                dispatch(getBozzeBollettinoPostaleSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.getBozzeBollettinoPostale = getBozzeBollettinoPostale;
/* get bozze - FINE */
/* get bozza - START */
function getBozzaBollettinoPostaleStart() {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_GET_BOZZA_START
    };
}
function getBozzaBollettinoPostaleSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_GET_BOZZA_SUCCESS,
        payload
    };
}
const getBozzaBollettinoPostale = (id, tipologiaBollettino) => async (dispatch, _, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(getBozzaBollettinoPostaleStart());
    if (extraArguments.mock) {
        Promise.resolve().then(() => require('../../mock/bozza_mav.json')).then(bozza => {
            dispatch(getBozzaBollettinoPostaleSuccess((0, api_rest_1.BollettinoPostaleDtoFromJSON)(bozza)));
            dispatch((0, general_actions_1.setLoader)(false));
        });
    }
    else {
        const getBozzaBollettinoPostaleRequest = {
            id: id,
            tipologiaBollettino: tipologiaBollettino
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.BollettinoPostaleControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).getBozzaBollettinoPostale(getBozzaBollettinoPostaleRequest).then((response) => {
                dispatch(getBozzaBollettinoPostaleSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.getBozzaBollettinoPostale = getBozzaBollettinoPostale;
/* get bozza - FINE */
/* add bozza - START */
function addBozzaBollettinoPostaleStart() {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_ADD_BOZZA_START
    };
}
function addBozzaBollettinoPostaleSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_ADD_BOZZA_SUCCESS,
        payload
    };
}
const addBozzaBollettinoPostale = (funzioneDispositiva) => async (dispatch, getState, extraArguments) => {
    const bollettinoPostale = getState().bollettinoPostale;
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(addBozzaBollettinoPostaleStart());
    if (extraArguments.mock) {
        Promise.resolve().then(() => require('../../mock/bozza_mav_response.json')).then(bozza => {
            dispatch(addBozzaBollettinoPostaleSuccess((0, api_rest_1.BollettinoPostaleDtoFromJSON)(bozza)));
            dispatch((0, general_actions_1.setLoader)(false));
        });
    }
    else {
        const addBozzaBollettinoPostaleRequest = {
            bollettinoPostaleDto: {
                ...funzioneDispositiva === 'bianco' ? (0, bollettinoPostale_selectors_1.buildBollettinoPostaleBianco)(bollettinoPostale) : (0, bollettinoPostale_selectors_1.buildBollettinoPostalePremarcato)(bollettinoPostale),
                bozza: {
                    dataUltimaModifica: moment().toDate()
                }
            }
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.BollettinoPostaleControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).addBozzaBollettinoPostale(addBozzaBollettinoPostaleRequest).then((response) => {
                dispatch((0, general_actions_1.addSnackbar)('bollettinoPostale.nuovaBozzabollettinoPostaleSalvata'));
                dispatch(addBozzaBollettinoPostaleSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
/* add bozza - FINE */
/* del bozza - START */
function delBozzaBollettinoPostaleStart() {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_DELETE_BOZZA_START
    };
}
function delBozzaBollettinoPostaleSuccess(id) {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_DELETE_BOZZA_SUCCESS,
        payload: id
    };
}
const delBozzaBollettinoPostale = (id) => async (dispatch, _, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(delBozzaBollettinoPostaleStart());
    if (extraArguments.mock) {
        Promise.resolve().then(() => require('../../mock/bozza_mav.json')).then(bozza => {
            dispatch(delBozzaBollettinoPostaleSuccess(id));
            dispatch((0, general_actions_1.setLoader)(false));
        });
    }
    else {
        const delBozzaBollettinoPostaleRequest = {
            id: id
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.BollettinoPostaleControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).deleteBozzaBollettinoPostale(delBozzaBollettinoPostaleRequest).then(() => {
                dispatch(delBozzaBollettinoPostaleSuccess(id));
                dispatch((0, general_actions_1.addSnackbar)('bollettinoPostale.bozzaEliminataConSuccesso'));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.delBozzaBollettinoPostale = delBozzaBollettinoPostale;
/* del bozza - FINE */
/* update bozza - START */
function updateBozzaBollettinoPostaleStart() {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_UPDATE_BOZZA_START
    };
}
function updateBozzaBollettinoPostaleSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_UPDATE_BOZZA_SUCCESS,
        payload
    };
}
const updateBozzaBollettinoPostale = (funzioneDispositiva) => async (dispatch, getState, extraArguments) => {
    const bollettinoPostale = getState().bollettinoPostale;
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(updateBozzaBollettinoPostaleStart());
    if (extraArguments.mock) {
        Promise.resolve().then(() => require('../../mock/bozza_mav_response.json')).then(bozza => {
            dispatch(updateBozzaBollettinoPostaleSuccess((0, api_rest_1.BollettinoPostaleDtoFromJSON)(bozza)));
            dispatch((0, general_actions_1.setLoader)(false));
        });
    }
    else {
        const idCurrentBozza = bollettinoPostale.currentBozza.id || 0;
        const updateBozzaBollettinoPostaleRequest = {
            id: idCurrentBozza,
            bollettinoPostaleDto: {
                id: idCurrentBozza,
                ...funzioneDispositiva === 'bianco' ? (0, bollettinoPostale_selectors_1.buildBollettinoPostaleBianco)(bollettinoPostale) : (0, bollettinoPostale_selectors_1.buildBollettinoPostalePremarcato)(bollettinoPostale),
                bozza: {
                    dataUltimaModifica: moment().toDate()
                }
            }
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.BollettinoPostaleControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).updateBozzaBollettinoPostale(updateBozzaBollettinoPostaleRequest).then((response) => {
                dispatch(updateBozzaBollettinoPostaleSuccess(response));
                dispatch((0, general_actions_1.addSnackbar)('bollettinoPostale.bozzaAggiornata'));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
/* update bozza - FINE */
/* get oneclick - START */
function getOneclickBollettinoPostaleStart() {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_GET_ONECLICK_START
    };
}
function getOneclickBollettinoPostaleSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_GET_ONECLICK_SUCCESS,
        payload
    };
}
const getOneClickBollettinoPostaleBianco = () => async (dispatch, getState, extraArguments) => {
    (0, exports.getOneClickBollettinoPostale)('BIANCO')(dispatch, getState, extraArguments);
};
exports.getOneClickBollettinoPostaleBianco = getOneClickBollettinoPostaleBianco;
const getOneClickBollettinoPostale = (tipoOperazione) => async (dispatch, _, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(getOneclickBollettinoPostaleStart());
    if (extraArguments.mock) {
        Promise.resolve().then(() => require('../../mock/oneclick.json')).then(parametri => {
            dispatch(getOneclickBollettinoPostaleSuccess((0, api_rest_1.OperazioniOneClickDtoFromJSON)(parametri)));
            dispatch((0, general_actions_1.setLoader)(false));
        });
    }
    else {
        const getOneclickBollettinoPostaleSepaRequest = {
            operazioniOneClickInputDto: {
                tipoOperazione: tipoOperazione
            }
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.BollettinoPostaleControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).operazioniOneClickBollettinoPostale(getOneclickBollettinoPostaleSepaRequest).then((response) => {
                dispatch(getOneclickBollettinoPostaleSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.getOneClickBollettinoPostale = getOneClickBollettinoPostale;
/* get oneclick - FINE */
/* set form values - START */
function setBollettinoPostaleSetRapportoSelezionato(rapportoSelezionato) {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_SET_RAPPORTO_SELEZIONATO,
        payload: rapportoSelezionato
    };
}
exports.setBollettinoPostaleSetRapportoSelezionato = setBollettinoPostaleSetRapportoSelezionato;
function setBollettinoPostaleSetIdUtenza(value) {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_SET_ID_UTENZA,
        payload: value
    };
}
exports.setBollettinoPostaleSetIdUtenza = setBollettinoPostaleSetIdUtenza;
function setBollettinoPostaleSetImporto(value) {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_SET_IMPORTO,
        payload: value
    };
}
exports.setBollettinoPostaleSetImporto = setBollettinoPostaleSetImporto;
function setBollettinoPostaleSetEsecutore(value) {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_SET_ESECUTORE,
        payload: value
    };
}
exports.setBollettinoPostaleSetEsecutore = setBollettinoPostaleSetEsecutore;
function setBollettinoPostaleSetIndirizzo(value) {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_SET_INDIRIZZO,
        payload: value
    };
}
exports.setBollettinoPostaleSetIndirizzo = setBollettinoPostaleSetIndirizzo;
function setBollettinoPostaleSetProvincia(value) {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_SET_PROVINCIA,
        payload: value
    };
}
exports.setBollettinoPostaleSetProvincia = setBollettinoPostaleSetProvincia;
function setBollettinoPostaleSetCitta(value) {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_SET_CITTA,
        payload: value
    };
}
exports.setBollettinoPostaleSetCitta = setBollettinoPostaleSetCitta;
function setBollettinoPostaleSetCap(value) {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_SET_CAP,
        payload: value
    };
}
exports.setBollettinoPostaleSetCap = setBollettinoPostaleSetCap;
function setBollettinoPostaleSetNumeroBollettino(value) {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_SET_NUMERO_BOLLETTINO,
        payload: value
    };
}
exports.setBollettinoPostaleSetNumeroBollettino = setBollettinoPostaleSetNumeroBollettino;
function setBollettinoPostaleSetTipoDocumento(value) {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_SET_TIPO_DOCUMENTO,
        payload: value
    };
}
exports.setBollettinoPostaleSetTipoDocumento = setBollettinoPostaleSetTipoDocumento;
function setBollettinoPostaleSetTipoDataPagamento(value) {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_SET_DATA_PAGAMENTO,
        payload: value
    };
}
exports.setBollettinoPostaleSetTipoDataPagamento = setBollettinoPostaleSetTipoDataPagamento;
function setBollettinoPostaleSetStepAction(value) {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_SET_STEP,
        payload: value
    };
}
exports.setBollettinoPostaleSetStepAction = setBollettinoPostaleSetStepAction;
const setBollettinoPostaleSetStep = (i) => async (dispatch, _, extraArguments) => {
    dispatch(setBollettinoPostaleSetStepAction(i));
    if (extraArguments.platform == 'mobile') {
        dispatch((0, general_actions_1.setBottomTabBarVisible)(i != 2));
    }
};
exports.setBollettinoPostaleSetStep = setBollettinoPostaleSetStep;
function setBollettinoPostaleSetBozzaSalvata(value) {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_SET_BOZZA_SALVATA,
        payload: value
    };
}
exports.setBollettinoPostaleSetBozzaSalvata = setBollettinoPostaleSetBozzaSalvata;
function setBollettinoPostaleSetFormSubmitted(value) {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_SET_FORM_SUBMITTED,
        payload: value
    };
}
exports.setBollettinoPostaleSetFormSubmitted = setBollettinoPostaleSetFormSubmitted;
function setBollettinoPostaleSetRipeti(value) {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_SET_RIPETI,
        payload: value
    };
}
exports.setBollettinoPostaleSetRipeti = setBollettinoPostaleSetRipeti;
function resetBollettinoPostale() {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_RESET
    };
}
exports.resetBollettinoPostale = resetBollettinoPostale;
function setBollettinoPostaleSetCausale(value) {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_SET_CAUSALE,
        payload: value
    };
}
exports.setBollettinoPostaleSetCausale = setBollettinoPostaleSetCausale;
function setBollettinoPostaleSetIntestatario(value) {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_SET_INTESTATARIO,
        payload: value
    };
}
exports.setBollettinoPostaleSetIntestatario = setBollettinoPostaleSetIntestatario;
function setBollettinoPostaleSetSalva1Click(value) {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_SET_SALVA_1CLICK,
        payload: value
    };
}
exports.setBollettinoPostaleSetSalva1Click = setBollettinoPostaleSetSalva1Click;
function setBollettinoPostaleSetAlias1Click(value) {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_SET_ALIAS_1CLICK,
        payload: value
    };
}
exports.setBollettinoPostaleSetAlias1Click = setBollettinoPostaleSetAlias1Click;
/* set form values - FINE */
/* set other values - START */
function getBollettinoFromBozza(bozza, noBozza = false) {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_GET_BOLLETTINO_FROM_BOZZA,
        payload: bozza,
        noBozza
    };
}
exports.getBollettinoFromBozza = getBollettinoFromBozza;
function setRiepilogoRevocaBollettinoPostale(riepilogo) {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_SET_RIEPILOGO_REVOCA,
        payload: riepilogo
    };
}
exports.setRiepilogoRevocaBollettinoPostale = setRiepilogoRevocaBollettinoPostale;
function setProvenienzaRevocaBollettinoPostale(provenienza) {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_SET_PROVENIENZA,
        payload: provenienza
    };
}
exports.setProvenienzaRevocaBollettinoPostale = setProvenienzaRevocaBollettinoPostale;
function setBollettinoPostaleRevocaSetStepAction(i) {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_STEP_REVOCA,
        payload: i
    };
}
const setBollettinoPostaleRevocaSetStep = (i) => async (dispatch, _, extraArguments) => {
    dispatch(setBollettinoPostaleRevocaSetStepAction(i));
    if (extraArguments.platform == 'mobile') {
        dispatch((0, general_actions_1.setBottomTabBarVisible)(i != 1));
    }
};
exports.setBollettinoPostaleRevocaSetStep = setBollettinoPostaleRevocaSetStep;
function setBollettinoPostaleSalvaBozzaValidation() {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_SET_SALVA_BOZZA_VALIDATION
    };
}
exports.setBollettinoPostaleSalvaBozzaValidation = setBollettinoPostaleSalvaBozzaValidation;
function setBollettinoPostaleTipoSelected(tipo) {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_SET_TIPO_BOLLETTINO_SELECTED,
        payload: tipo
    };
}
exports.setBollettinoPostaleTipoSelected = setBollettinoPostaleTipoSelected;
/* set other values - FINE */
/* get info revoca - START */
function getInfoRevocaBollettinoPostaleStart() {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_GET_INFO_REVOCA_START
    };
}
function getInfoRevocaBollettinoPostaleSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_GET_INFO_REVOCA_SUCCESS,
        payload
    };
}
const getInfoRevocaBollettinoPostaleBianco = (idDispositiva) => async (dispatch, getState, extraArguments) => {
    (0, exports.getInfoRevocaBollettinoPostale)(idDispositiva)(dispatch, getState, extraArguments);
};
exports.getInfoRevocaBollettinoPostaleBianco = getInfoRevocaBollettinoPostaleBianco;
const getInfoRevocaBollettinoPostalePremarcato = (idDispositiva) => async (dispatch, getState, extraArguments) => {
    (0, exports.getInfoRevocaBollettinoPostale)(idDispositiva)(dispatch, getState, extraArguments);
};
exports.getInfoRevocaBollettinoPostalePremarcato = getInfoRevocaBollettinoPostalePremarcato;
const getInfoRevocaBollettinoPostale = (idDispositiva, eseguiInit, chiamataUscente, offline) => async (dispatch, _, extraArguments) => {
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(getInfoRevocaBollettinoPostaleStart());
    if (extraArguments.mock) {
        Promise.resolve().then(() => require('../../mock/autenticazione-bonifico.json')).then(parametri => {
            dispatch(getInfoRevocaBollettinoPostaleSuccess((0, api_rest_1.InformazioniAutenticazioneDispositivaDtoFromJSON)(parametri)));
            dispatch((0, general_actions_1.setLoader)(false));
        });
    }
    else {
        const requestParameters = {
            idDispositiva: idDispositiva,
            chiamataUscente,
            eseguiInit,
            offline: !!offline
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.BollettinoPostaleControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).informazioniAutenticazioneRevocaBollettinoPostale(requestParameters).then((response) => {
                dispatch(getInfoRevocaBollettinoPostaleSuccess(response));
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error)));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.getInfoRevocaBollettinoPostale = getInfoRevocaBollettinoPostale;
/* get info revoca - FINE */
/* autorizza revoca - START */
function autorizzaRevocaBollettinoPostaleStart() {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_AUTORIZZA_REVOCA_START
    };
}
function autorizzaRevocaBollettinoPostaleSuccess(payload) {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_AUTORIZZA_REVOCA_SUCCESS,
        payload
    };
}
const autorizzaRevocaBollettinoPostaleBianco = (idDispositiva, credenziale, bollettino) => async (dispatch, getState, extraArguments) => {
    (0, exports.autorizzaRevocaBollettinoPostale)(idDispositiva, credenziale, bollettino)(dispatch, getState, extraArguments);
};
exports.autorizzaRevocaBollettinoPostaleBianco = autorizzaRevocaBollettinoPostaleBianco;
const autorizzaRevocaBollettinoPostalePremarcato = (idDispositiva, credenziale, bollettino) => async (dispatch, getState, extraArguments) => {
    (0, exports.autorizzaRevocaBollettinoPostale)(idDispositiva, credenziale, bollettino)(dispatch, getState, extraArguments);
};
exports.autorizzaRevocaBollettinoPostalePremarcato = autorizzaRevocaBollettinoPostalePremarcato;
const autorizzaRevocaBollettinoPostale = (idDispositiva, credenziale, bollettino) => async (dispatch, _, extraArguments) => {
    var _a, _b;
    dispatch((0, general_actions_1.setLoader)(true));
    dispatch(autorizzaRevocaBollettinoPostaleStart());
    if (extraArguments.mock) {
        Promise.resolve().then(() => require('../../mock/autorizza_revoca_mav.json')).then(parametri => {
            dispatch(autorizzaRevocaBollettinoPostaleSuccess((0, api_rest_1.EsitoAutorizzazioneDisposizioneBollettinoPostaleDtoFromJSON)(parametri)));
            dispatch((0, general_actions_1.setLoader)(false));
        });
    }
    else {
        const requestParameters = {
            bollettinoPostaleRevocaIn: {
                credenziale,
                annoInserimento: (_a = bollettino.scadenziereUnico) === null || _a === void 0 ? void 0 : _a.anno,
                progressivoInserimento: (_b = bollettino.scadenziereUnico) === null || _b === void 0 ? void 0 : _b.progressivo,
                codiceRapporto: bollettino.contoAddebito
            }
        };
        extraArguments.getItem('jwt').then((jwt) => {
            new api_rest_1.BollettinoPostaleControllerApi((0, general_configuration_1.default)(api_rest_1.Configuration, extraArguments, undefined, jwt)).operazioneAutenticataBollettinoPostale(requestParameters).then((response) => {
                dispatch(autorizzaRevocaBollettinoPostaleSuccess(response));
                extraArguments.sendEventToMatomo('BOLLETTINO_POSTALE_REVOCA', `esito revoca dispositiva BOLLETTINO_POSTALE_REVOCA ${response.stato}`, 'REVOCA_DISPOSITIVA');
            }).catch(async (error) => {
                dispatch(generalError(await (0, helpers_1.formatError)(error), false, extraArguments.sendEventToMatomo, 'BOLLETTINO_POSTALE_REVOCA', 'REVOCA_DISPOSITIVA'));
            }).finally(() => {
                dispatch((0, general_actions_1.setLoader)(false));
            });
        });
    }
};
exports.autorizzaRevocaBollettinoPostale = autorizzaRevocaBollettinoPostale;
/* autorizza revoca - FINE */
function resetEsitoBollettino() {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_RESET_ESITO
    };
}
exports.resetEsitoBollettino = resetEsitoBollettino;
function resetRiepilogoBollettino() {
    return {
        type: __1.EReduxActionTypes.BOLLETTINO_POSTALE_RESET_RIEPILOGO
    };
}
exports.resetRiepilogoBollettino = resetRiepilogoBollettino;
const shouldUpdateBozzaBollettinoPostale = (funzioneDispositiva) => async (dispatch, getState, extraArguments) => {
    const state = getState().bollettinoPostale;
    if ((0, bollettinoPostale_selectors_1.checkUpdateBozzaBollettinoPostale)(state)) {
        dispatch(updateBozzaBollettinoPostale(funzioneDispositiva));
    }
    else {
        dispatch(addBozzaBollettinoPostale(funzioneDispositiva));
    }
};
exports.shouldUpdateBozzaBollettinoPostale = shouldUpdateBozzaBollettinoPostale;
